<template>
    <div class="register-page" :style="registerPageBG">
      <div class="register-page-content">
        <div class="register-box">
          <el-form :model="newUserInfo" :size="'small'" label-width="110px" :rules="newUserInfoRules" ref="newUserInfo">
            <div class="title">快速注册</div>
            <el-form-item label="角色" prop="roleNum" style="margin-bottom: 20px">
              <el-radio-group v-model="newUserInfo.roleNum">
                <el-radio :label="'ROLE0002'">求职者</el-radio>
                <el-radio :label="'ROLE0001'">招聘者</el-radio>
              </el-radio-group>
            </el-form-item>
            <el-form-item label="手机号或邮箱" prop="phone_email">
              <el-input ref="phone_email" v-model="newUserInfo.phone_email" prefix-icon="el-icon-mobile-phone" placeholder="手机号或邮箱"
                        clearable></el-input>
            </el-form-item>
            <el-form-item label="验证码" prop="loginVerificationCode">
              <el-input ref="loginVerificationCode" v-model="newUserInfo.loginVerificationCode"
                        class="login-verification-code"
                        prefix-icon="el-icon-message" placeholder="输入验证码">
                <el-button class="send-msg" v-if="verificationCodeFlag" slot="append" @click="checkPhoneNumberAddSendMsg">发送验证码</el-button>
                <div v-else slot="append" class="login-waiting-code">已发送 {{waitingCodeTime}} s</div>
              </el-input>
            </el-form-item>
            <!--<el-form-item label="用户名" prop="userName">
              <el-input v-model="newUserInfo.userName" prefix-icon="el-icon-user" placeholder="输入用户名" clearable></el-input>
            </el-form-item>
            <el-form-item label="密码" prop="passWord">
              <el-input v-model="newUserInfo.passWord" prefix-icon="el-icon-key" placeholder="输入密码"
                        show-password></el-input>
            </el-form-item>
            <el-form-item label="确认密码" prop="passWordConfirm">
              <el-input v-model="newUserInfo.passWordConfirm" prefix-icon="el-icon-key" placeholder="确认密码"
                        show-password></el-input>
            </el-form-item>-->
          </el-form>
          <div slot="footer" class="dialog-footer">
            <el-button @click="cancel()" size="small">取 消</el-button>
            <el-button type="primary" @click="submit('newUserInfo')" size="small">确 定</el-button>
          </div>
          <el-dialog :visible.sync="registerSuccessToConfirm" :closeOnClickModal="false" :showClose="false"
                     :destroyOnClose="true" :appendToBody="true">
            <div>注册成功，请登录后完善用户信息，继续...</div>
            <div slot="footer" class="dialog-footer">
              <el-button @click="cancel()" size="small">取 消</el-button>
              <el-button type="primary" @click="confirm()" size="small">登 录</el-button>
            </div>
          </el-dialog>
        </div>
        <div class="footer-copyright">Copyright © 2022 www.hangzhourenge.cn 浙ICP备2022018352号-2</div>
      </div>
    </div>
</template>

<script>
export default {
  name: 'RegisterUser',
  data () {
    // 手机号或邮箱校验
    let validatePhoneOrEmail = (rule, value, callback) => {
      if (!(/^1[3456789]\d{9}$/.test(this.newUserInfo.phone_email.trim())) &&
        !(new RegExp('^[a-z0-9]+([._\\-]*[a-z0-9])*@([a-z0-9]+[-a-z0-9]*[a-z0-9]+.){1,63}[a-z0-9]+$').test(this.newUserInfo.phone_email))) {
        callback(new Error('请输入正确的手机号码或邮箱'))
      }
      callback()
    }
    // 验证码校验
    let validateVerificationCode = (rule, value, callback) => {
      if (!(/^\d{6}$/.test(this.newUserInfo.loginVerificationCode.trim()))) {
        callback(new Error('请输入6位正确的验证码'))
      }
      callback()
    }
    // 用户名校验 /^[\u4E00-\u9FA5\uF900-\uFA2D|\w]{2,20}$/ 中文，英文字母，数字及下划线组成，长度2-20位
    let validateUserName = (rule, value, callback) => {
      if (!(/^[a-zA-Z0-9_-]{4,20}$/.test(this.newUserInfo.userName.trim()))) {
        callback(new Error('用户名由字母，数字，下划线或减号组成，长度4-20位'))
      }
      callback()
    }
    // 密码正则校验
    let validatePass1 = (rule, value, callback) => {
      if (!/^[\w_-]{6,20}$/.test(this.newUserInfo.passWord.trim())) {
        callback(new Error('请输入6-20位字母、数字或特殊字符(-_)作为密码'))
      }
      callback()
    }
    // 密码正则校验
    let validatePass2 = (rule, value, callback) => {
      if (this.newUserInfo.passWordConfirm.trim() !== this.newUserInfo.passWord.trim()) {
        callback(new Error('两次输入密码不一致'))
      }
      callback()
    }
    return {
      registerSuccessToConfirm: false,
      registerPageBG: {
        backgroundImage: `url(${require('../assets/login_bg1.jpg')})`,
        width: '100vw',
        height: '100vh',
        backgroundSize: 'cover'
      },
      newUserInfo: {
        roleNum: 'ROLE0002',
        phone_email: '',
        loginVerificationCode: '',
        userName: '',
        passWord: '',
        passWordConfirm: ''
      },
      newUserInfoRules: {
        roleNum: [
          {required: true}
        ],
        phone_email: [
          {required: true, message: '请输入手机号或邮箱', trigger: 'blur'},
          {validator: validatePhoneOrEmail, trigger: 'blur'}
        ],
        userName: [
          {required: true, message: '请输入用户名', trigger: 'blur'},
          {validator: validateUserName, trigger: 'blur'}
        ],
        passWord: [
          {required: true, message: '请输入密码', trigger: 'blur'},
          {validator: validatePass1, trigger: 'blur'}
        ],
        passWordConfirm: [
          {required: true, message: '请确认密码', trigger: 'blur'},
          {validator: validatePass2, trigger: 'blur'}
        ],
        loginVerificationCode: [
          {required: true, message: '请输入验证码', trigger: 'blur'},
          {validator: validateVerificationCode, trigger: 'blur'}
        ]
      },
      verificationCodeFlag: true,
      waitingCodeTime: 60
    }
  },
  methods: {
    initUerInfo () {
      this.newUserInfo = {
        roleNum: 'ROLE0002',
        phone_email: '',
        loginVerificationCode: ''
        // userName: '',
        // passWord: '',
        // passWordConfirm: ''
      }
    },
    checkPhoneNumberAddSendMsg () {
      // 表单只校验一项
      this.$refs['newUserInfo'].validateField('phone_email', (errMsg) => {
        if (!errMsg) {
          this.verificationCodeFlag = false
          this.$refs.loginVerificationCode.focus()
          let timer = setInterval(() => {
            this.waitingCodeTime--
            if (this.waitingCodeTime === 0) {
              this.waitingCodeTime = 60
              clearInterval(timer)
              this.verificationCodeFlag = true
            }
          }, 1000)
          // 调接口发送验证码
          this.$http.get(this.$api.getVerificationCode.url, {
            number: this.newUserInfo.phone_email
          }).then(res => {
            console.log(res)
            console.log('前台需要校验验证码么？')
          })
        } else {
          this.$refs.phone_email.focus()
        }
      })
    },
    submit (formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          // todo：调接口注册
          this.$http.post(this.$api.registerUser.url, {
            number: this.newUserInfo.phone_email,
            code: this.newUserInfo.loginVerificationCode,
            roleNum: this.newUserInfo.roleNum
            // userName: this.newUserInfo.userName,
            // password: this.newUserInfo.passWord,
            // roleNum: this.newUserInfo.roleNum
          }).then(res => {
            console.log(res)
            if (res && res.code === 200) {
              // this.registerSuccessToConfirm = true
              // this.$emit('closeRegisterDialog')
              this.$message.success(res.msg)
              this.cancel()
            } else {
              this.$message.error(res.msg)
            }
          })
          // this.$emit('closeRegisterDialog')
        } else {
          return false
        }
      })
    },
    cancel () {
      this.$router.push({
        name: 'Login',
        params: null
      })
    },
    confirm () {
      this.registerSuccessToConfirm = false
      this.initUerInfo()
      this.$emit('closeRegisterDialog', 'login')
    }
  }
}
</script>

<style scoped>
.register-page {
  height: 100vh;
  min-height: 768px;
  position: relative;
}
  .register-page-content {
    width: 1200px;
    margin: auto;
    height: 100%;
    position: relative;
  }
  .register-box {
    position: relative;
    width: 360px;
    background: #ffffff;
    padding: 20px;
    float: right;
    margin-top: 200px;
    box-shadow: 1px 2px 15px rgba(0, 0, 0, .3);
    border-radius: 2px;
  }
  .title {
    text-align: left;
    font-size: 16px;
    color: #666666;
    position: relative;
  }
  .title::before {
    position: absolute;
    content: '';
    width: 3px;
    height: 20px;
    background: #409EFF;
    left: -20px;
    top: 1px;
  }
/deep/ .el-form-item {
  text-align: left;
  margin-bottom: 30px;
}
  .footer-copyright {
    width: 100%;
    color: #ffffff;
    font-size: 14px;
    text-align: center;
    position: absolute;
    bottom: 12px;
  }
</style>



// WEBPACK FOOTER //
// src/components/RegisterUser.vue